<template>
  <div class="app-container">
    <el-form :model="queryParams" ref="queryForm" size="small" :inline="true" v-show="showSearch" label-width="68px">
      <el-form-item label="报告id" prop="reportId">
        <el-input
          v-model="queryParams.reportId"
          placeholder="请输入报告id"
          clearable
          @keyup.enter.native="handleQuery"
        />
      </el-form-item>
      <el-form-item label="检查类型" prop="examItem">
        <el-input
          v-model="queryParams.examItem"
          placeholder="请输入检查类型"
          clearable
          @keyup.enter.native="handleQuery"
        />
      </el-form-item>
      <el-form-item label="患者名称" prop="userPatientName">
        <el-input
          v-model="queryParams.userPatientName"
          placeholder="请输入患者名称"
          clearable
          @keyup.enter.native="handleQuery"
        />
      </el-form-item>
      <el-form-item label="报告时间" prop="issued">
        <el-date-picker
            style="width: 100%"
            v-model="queryParams.issued"
            clearable
            placeholder="报告发布时间"
            type="date"
            value-format="yyyy-MM-dd">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="创建时间" prop="createDate">
        <el-date-picker
            style="width: 100%"
            v-model="queryParams.createDate"
            clearable
            placeholder="创建时间"
            type="date"
            value-format="yyyy-MM-dd">
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" size="mini" @click="handleQuery">搜索</el-button>
        <el-button icon="el-icon-refresh" size="mini" @click="resetQuery">重置</el-button>
      </el-form-item>
    </el-form>

    <el-row :gutter="10" class="mb8">
      <el-col :span="1.5">
        <el-button
          type="warning"
          plain
          icon="el-icon-download"
          size="mini"
          @click="handleExport"
          v-hasPermi="['his:HisDiagnosticExaminationReport:export']"
        >导出</el-button>
      </el-col>
      <right-toolbar :showSearch.sync="showSearch" @queryTable="getList"></right-toolbar>
    </el-row>

    <el-table v-loading="loading" :data="reportList" @selection-change="handleSelectionChange">
      <el-table-column label="用户id" align="center" prop="userId" />
      <el-table-column label="患者名称" align="center" prop="userPatientName" />
<!--      <el-table-column label="来源请求id" align="center" prop="requestId" />-->
      <el-table-column label="报告id" align="center" prop="reportId" width="150"/>
<!--      <el-table-column label="报告编号" align="center" prop="requestNo" />-->
<!--      <el-table-column label="超声序号" align="center" prop="examSerialNo" />-->
      <el-table-column label="检查类型code" align="center" prop="examItemCode" />
      <el-table-column label="检查类型" align="center" prop="examItem" :show-overflow-tooltip='true' width="150"/>
<!--      <el-table-column label="检查部位code" align="center" prop="examPosiCode" />-->
<!--      <el-table-column label="检查部位" align="center" prop="examPosi" />-->
      <el-table-column label="诊断" align="center" prop="codedDiagnosis" :show-overflow-tooltip='true' width="200"/>
      <el-table-column label="结论" align="center" prop="conclusion" :show-overflow-tooltip='true' width="200"/>
      <el-table-column label="发布时间" align="center" prop="issued" width="180">
        <template slot-scope="scope">
          <span>{{ parseTime(scope.row.issued, '{y}-{m}-{d} {h}:{i}') }}</span>
        </template>
      </el-table-column>
<!--      <el-table-column label="报告请求路径" align="center" prop="fullUrl" />-->

<!--      <el-table-column label="患者编号" align="center" prop="userVisitNo" />-->
<!--      <el-table-column label="患者性别" align="center" prop="userGender" />-->
      <el-table-column label="患者年龄" align="center" prop="userAge" />
<!--      <el-table-column label="患者病床" align="center" prop="userBedNo" />-->
<!--      <el-table-column label="科室名称" align="center" prop="requestDept" />-->
      <el-table-column label="开单医生" align="center" prop="requestDoctor" />
<!--      <el-table-column label="审核医生" align="center" prop="reportReviewDoctor" />-->
<!--      <el-table-column label="报告pdf" align="center" prop="presentedFileUrl" />-->
<!--      <el-table-column label="创建时间" align="center" prop="createDate" width="180">-->
<!--        <template slot-scope="scope">-->
<!--          <span>{{ parseTime(scope.row.createDate, '{y}-{m}-{d} {h}:{i}') }}</span>-->
<!--        </template>-->
<!--      </el-table-column>-->
      <el-table-column label="操作" align="center" class-name="small-padding fixed-width">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="text"
            icon="el-icon-edit"
            @click="handleUpdate(scope.row)"
            v-hasPermi="['his:HisDiagnosticExaminationReport:edit']"
          >查看</el-button>
        </template>
      </el-table-column>
    </el-table>

    <pagination
      v-show="total>0"
      :total="total"
      :page.sync="queryParams.pageNum"
      :limit.sync="queryParams.pageSize"
      @pagination="getList"
    />

    <!-- 添加或修改His系统报告记录对话框 -->
    <el-dialog :title="title" :visible.sync="open" width="500px" append-to-body>
      <el-form ref="form" :model="form" :rules="rules" label-width="80px">

        <el-form-item label="诊断" prop="codedDiagnosis">
          <el-input v-model="form.codedDiagnosis" type="textarea" placeholder="请输入内容" :autosize="{ minRows: 10  }"/>
        </el-form-item>
        <el-form-item label="结论" prop="conclusion">
          <el-input v-model="form.conclusion" type="textarea" placeholder="请输入内容" :autosize="{ minRows: 4  }"/>
        </el-form-item>

        <el-form-item label="用户id" prop="userId">
          <el-input v-model="form.userId" placeholder="请输入用户id" />
        </el-form-item>
        <el-form-item label="来源请求id" prop="requestId">
          <el-input v-model="form.requestId" placeholder="请输入来源请求id" />
        </el-form-item>
        <el-form-item label="报告id" prop="reportId">
          <el-input v-model="form.reportId" placeholder="请输入报告id" />
        </el-form-item>
        <el-form-item label="报告请求编号" prop="requestNo">
          <el-input v-model="form.requestNo" placeholder="请输入报告请求编号" />
        </el-form-item>
        <el-form-item label="超声序号" prop="examSerialNo">
          <el-input v-model="form.examSerialNo" placeholder="请输入超声序号" />
        </el-form-item>
        <el-form-item label="检查类型code" prop="examItemCode">
          <el-input v-model="form.examItemCode" placeholder="请输入检查类型code" />
        </el-form-item>
        <el-form-item label="检查类型" prop="examItem">
          <el-input v-model="form.examItem" placeholder="请输入检查类型" />
        </el-form-item>
        <el-form-item label="检查部位code" prop="examPosiCode">
          <el-input v-model="form.examPosiCode" placeholder="请输入检查部位code" />
        </el-form-item>
        <el-form-item label="检查部位" prop="examPosi">
          <el-input v-model="form.examPosi" placeholder="请输入检查部位" />
        </el-form-item>

        <el-form-item label="发布时间" prop="issued">
          <el-date-picker clearable
            v-model="form.issued"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="请选择发布时间">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="患者名称" prop="userPatientName">
          <el-input v-model="form.userPatientName" placeholder="请输入患者名称" />
        </el-form-item>
        <el-form-item label="患者编号" prop="userVisitNo">
          <el-input v-model="form.userVisitNo" placeholder="请输入患者编号" />
        </el-form-item>
        <el-form-item label="患者性别" prop="userGender">
          <el-input v-model="form.userGender" placeholder="请输入患者性别" />
        </el-form-item>
        <el-form-item label="患者年龄" prop="userAge">
          <el-input v-model="form.userAge" placeholder="请输入患者年龄" />
        </el-form-item>
      </el-form>
<!--      <div slot="footer" class="dialog-footer">-->
<!--        <el-button type="primary" @click="submitForm">确 定</el-button>-->
<!--        <el-button @click="cancel">取 消</el-button>-->
<!--      </div>-->
    </el-dialog>
  </div>
</template>

<script>
  import {addHisDiagnosticExaminationReport, delHisDiagnosticExaminationReport, getHisDiagnosticExaminationReport, listHisDiagnosticExaminationReport, updateHisDiagnosticExaminationReport} from "@/api/his/HisDiagnosticExaminationReport";

  export default {
  name: "HisDiagnosticExaminationReport",
  data() {
    return {
      // 遮罩层
      loading: true,
      // 选中数组
      ids: [],
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      // 显示搜索条件
      showSearch: true,
      // 总条数
      total: 0,
      // His系统报告记录表格数据
      reportList: [],
      // 弹出层标题
      title: "",
      // 是否显示弹出层
      open: false,
      // 查询参数
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        userId: null,
        requestId: null,
        reportId: null,
        requestNo: null,
        examSerialNo: null,
        examItemCode: null,
        examItem: null,
        examPosiCode: null,
        examPosi: null,
        codedDiagnosis: null,
        conclusion: null,
        issued: null,
        fullUrl: null,
        userPatientName: null,
        userVisitNo: null,
        userGender: null,
        userAge: null,
        userBirthDate: null,
        userBedNo: null,
        requestDept: null,
        requestDoctor: null,
        reportReviewDoctor: null,
        presentedFileUrl: null,
        createDate: null
      },
      // 表单参数
      form: {},
      // 表单校验
      rules: {
      }
    };
  },
  created() {
    this.getList();
  },
  methods: {
    /** 查询His系统报告记录列表 */
    getList() {
      this.loading = true;
      listHisDiagnosticExaminationReport(this.queryParams).then(response => {
        this.reportList = response.rows;
        this.total = response.total;
        this.loading = false;
      });
    },
    // 取消按钮
    cancel() {
      this.open = false;
      this.reset();
    },
    // 表单重置
    reset() {
      this.form = {
        id: null,
        userId: null,
        requestId: null,
        reportId: null,
        requestNo: null,
        examSerialNo: null,
        examItemCode: null,
        examItem: null,
        examPosiCode: null,
        examPosi: null,
        codedDiagnosis: null,
        conclusion: null,
        issued: null,
        fullUrl: null,
        userPatientName: null,
        userVisitNo: null,
        userGender: null,
        userAge: null,
        userBirthDate: null,
        userBedNo: null,
        requestDept: null,
        requestDoctor: null,
        reportReviewDoctor: null,
        presentedFileUrl: null,
        createDate: null
      };
      this.resetForm("form");
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParams.pageNum = 1;
      this.getList();
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.resetForm("queryForm");
      this.handleQuery();
    },
    // 多选框选中数据
    handleSelectionChange(selection) {
      this.ids = selection.map(item => item.id)
      this.single = selection.length!==1
      this.multiple = !selection.length
    },
    /** 新增按钮操作 */
    handleAdd() {
      this.reset();
      this.open = true;
      this.title = "添加His系统报告记录";
    },
    /** 修改按钮操作 */
    handleUpdate(row) {
      this.reset();
      const id = row.id || this.ids
      getHisDiagnosticExaminationReport(id).then(response => {
        this.form = response.data;
        this.open = true;
        this.title = "查看His系统报告记录";
      });
    },
    /** 提交按钮 */
    submitForm() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          if (this.form.id != null) {
            updateHisDiagnosticExaminationReport(this.form).then(response => {
              this.$modal.msgSuccess("修改成功");
              this.open = false;
              this.getList();
            });
          } else {
            addHisDiagnosticExaminationReport(this.form).then(response => {
              this.$modal.msgSuccess("新增成功");
              this.open = false;
              this.getList();
            });
          }
        }
      });
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      const ids = row.id || this.ids;
      this.$modal.confirm('是否确认删除His系统报告记录编号为"' + ids + '"的数据项？').then(function() {
        return delHisDiagnosticExaminationReport(ids);
      }).then(() => {
        this.getList();
        this.$modal.msgSuccess("删除成功");
      }).catch(() => {});
    },
    /** 导出按钮操作 */
    handleExport() {
      this.download('his/hisDiagnosticExaminationReport/export', {
        ...this.queryParams
      }, `report_${new Date().getTime()}.xlsx`)
    }
  }
};
</script>
